export type RouteState = {
  existingRouteOptimizer: any;
  isRouteOptimizationConfigUpdated: boolean;
};
export const initialState: RouteState = {
  existingRouteOptimizer: {},
  isRouteOptimizationConfigUpdated: false,
};
